import React from 'react'
import { RibbonOptions } from '../../../../helpers/BreachWallTypes'
import { PackageOptions } from '../../../BreachWallContent/BreachWallContent'
import {
    StyledSubscriptionInnerPriceContainer,
    StyledSubscriptionPriceTextContainer,
    StyledSubscriptionPrice,
    StyledSubscriptionSubPriceText,
    StyledRibbon,
} from '../../SubscriptionPackageRedesign2026.styled'

type SubscriptionInnerPriceContainerProps = {
    packageOptions: PackageOptions
    price: string
    ribbonTitle?: string
    ribbonOptions?: RibbonOptions
}
export const SubscriptionInnerPriceContainer = ({
    packageOptions,
    price,
    ribbonOptions,
    ribbonTitle,
}: SubscriptionInnerPriceContainerProps) => {
    return (
        <StyledSubscriptionInnerPriceContainer>
            <StyledSubscriptionPriceTextContainer>
                <StyledSubscriptionPrice packageOptions={packageOptions}>
                    {price}
                </StyledSubscriptionPrice>
                <StyledSubscriptionSubPriceText>
                    / week
                </StyledSubscriptionSubPriceText>
                {/* Styled only for ribbon option blue-pill atm */}
                {ribbonTitle && ribbonOptions === 'bluePillLight' && (
                    <StyledRibbon ribbonOption={'bluePillLight'}>
                        <span>{ribbonTitle}</span>
                    </StyledRibbon>
                )}
            </StyledSubscriptionPriceTextContainer>
        </StyledSubscriptionInnerPriceContainer>
    )
}
